import moment from "moment";
import dayjs from "dayjs";

export function taskStatusList() {
  return [
    { id: "1", label: "Cancelled" },
    { id: "2", label: "Completed" },
  ];
}

export function timeFormatList() {
  return [
    { id: "1", label: "Minutes (mm)" },
    { id: "2", label: "Minutes with Second (mm:ss)" },
  ];
}

export function quartersList() {
  return [
    { id: "0", label: "None selected" },
    { id: "1", label: "Compass FY Quarters" },
    { id: "2", label: "Calendar Year Quarters" },
  ];
}

export function timeFrameList() {
  return [
    { id: "1", label: "Daily" },
    { id: "2", label: "Weekly" },
    { id: "3", label: "Monthly" },
    { id: "4", label: "Yearly" },
  ];
}

export function taskTypeList() {
  return [
    { id: "1", label: "Scheduled" },
    { id: "2", label: "Demand" },
  ];
}

export function weekDayList() {
  return [
    { id: "1", label: "Sunday" },
    { id: "2", label: "Monday" },
    { id: "3", label: "Tuesday" },
    { id: "4", label: "Wednesday" },
    { id: "5", label: "Thursday" },
    { id: "6", label: "Friday" },
    { id: "7", label: "Saturday" },
  ];
}

export function durations() {
  return [
    { id: "rbDay", label: "Day" },
    { id: "rbWeek", label: "Week" },
    { id: "rbMonth", label: "Month" },
    { id: "rbQuarter", label: "Quarter" },
    { id: "rbYear", label: "Year" },
  ];
}

export function getMinuteSteps(params) {
  if (
    params[0]?.path === "NPC_Bed_Turn_by_Unit_Hour" ||
    params[0]?.path === "NPC_Workload_by_Time_of_Day"
  ) {
    return 60;
  }
  return 15;
}

export function buildReportUrl(params, facilitykey, arrObj) {
  let paramString = "SqlWhere=Fac" + facilitykey;

  paramString += "Func" + params["functionalAreaKey"];

  // Helper to extract time from various formats (dayjs, Date, ISO string, time string)
  const extractTime = (timeVal) => {
    if (!timeVal) return { hour: 0, minute: 0, second: 0 };

    // Handle dayjs objects
    if (dayjs.isDayjs(timeVal)) {
      return { hour: timeVal.hour(), minute: timeVal.minute(), second: timeVal.second() };
    }

    // Handle Date objects
    if (timeVal instanceof Date) {
      return { hour: timeVal.getUTCHours(), minute: timeVal.getUTCMinutes(), second: timeVal.getUTCSeconds() };
    }

    const timeStr = String(timeVal).trim();

    // If it's an ISO string, parse with moment UTC
    if (timeStr.includes('T')) {
      const m = moment.utc(timeVal);
      return { hour: m.hour(), minute: m.minute(), second: m.second() };
    }

    // Parse time string like " 12:00 AM" or "11:59 PM"
    const timePart = timeStr.replace(/^\s+/, '');
    const timeMatch = timePart.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);
    if (timeMatch) {
      let hour = parseInt(timeMatch[1], 10);
      const minute = parseInt(timeMatch[2], 10);
      const period = timeMatch[3];
      if (period) {
        if (period.toUpperCase() === 'PM' && hour !== 12) hour += 12;
        if (period.toUpperCase() === 'AM' && hour === 12) hour = 0;
      }
      return { hour, minute, second: 0 };
    }
    return { hour: 0, minute: 0, second: 0 };
  };

  // Use startDate for date + time from startDateTime
  let startDateTimeMoment = moment.utc(params.startDate, ["YYYY-MM-DD", "MM/DD/YYYY", moment.ISO_8601]);
  if (params.startDateTime) {
    const time = extractTime(params.startDateTime);
    startDateTimeMoment.hour(time.hour).minute(time.minute).second(time.second);
  }

  // Use endDate for date + time from endDateTime
  let endDateTimeMoment = moment.utc(params.endDate, ["YYYY-MM-DD", "MM/DD/YYYY", moment.ISO_8601]);
  if (params.endDateTime) {
    const time = extractTime(params.endDateTime);
    endDateTimeMoment.hour(time.hour).minute(time.minute).second(time.second);
  } else {
    endDateTimeMoment.hour(23).minute(59).second(59);
  }

  paramString += "Startdt" + startDateTimeMoment.format("YYYY-MM-DD HH:mm:ss");
  paramString += "Enddt" + endDateTimeMoment.format("YYYY-MM-DD HH:mm:ss");

  paramString +=
    "TskClass" + updateSelectAllValue(arrObj.taskClasses, params.taskClass, "");
  paramString +=
    "startUnit" +
    updateSelectAllValue(
      arrObj.units,
      params.startUnit,
      params.report[0]?.path
    );
  paramString +=
    "destUnit" + updateSelectAllValue(arrObj.units, params.destinationUnit, "");
  paramString +=
    "Tsktype" + updateSelectAllValue(taskTypeList(), params.routineStat, "");
  paramString +=
    "Tskstatus" + updateSelectAllValue(taskStatusList(), params.taskStatus, "");
  paramString +=
    "Prrty" + updateSelectAllValue(arrObj.priorities, params.taskPriority, "");
  paramString +=
    "Wkday" + updateSelectAllValue(weekDayList(), params.weekDays, "");

  // Helper to format time as HHmm for StartHr/EndHr
  const formatTimeAsHHmm = (timeVal) => {
    if (!timeVal || timeVal === "") return "-1";

    // Handle dayjs objects
    if (dayjs.isDayjs(timeVal)) {
      return timeVal.format("HHmm");
    }

    const timeStr = String(timeVal).trim();

    // Handle ISO strings
    if (timeStr.includes('T')) {
      return moment.utc(timeVal).format("HHmm");
    }

    // Handle time strings like "12:00 AM"
    return moment.utc(timeStr, ["hh:mm A", "HH:mm"]).format("HHmm");
  };

  paramString += "StartHr" + formatTimeAsHHmm(params.startTime);
  paramString += "EndHr" + formatTimeAsHHmm(params.endTime);

  paramString += "Time" + (params.timeFormat === "" ? 1 : params.timeFormat);
  paramString += "Qtr" + (params.quarters === "" ? 0 : params.quarters);
  paramString += "Timeframe" + (params.timeFrame === "" ? 0 : params.timeFrame);

  console.log("\n\nreport parameter string==> " + paramString);

  const RDLName = params.report?.path;
  if (RDLName) {
    const serverUrl = params.reportUrl;
    const parametersList = paramString + "&rs:format=HTML4.0";
    const form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute("action", serverUrl + RDLName);
    form.setAttribute("target", "_blank");

    const parameters = parametersList.split("&");
    for (let index = 0; index < parameters.length; index++) {
      let nameValuePair;
      let nameValues = [];
      const hiddenField = document.createElement("input");

      nameValuePair = parameters[index].toString();
      nameValues = nameValuePair.split("=");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", nameValues[0]);
      hiddenField.setAttribute("value", nameValues[1]);
      form.appendChild(hiddenField);
    }

    document.body.appendChild(form);
    form.submit();
  } else {
    alert("Report (RDL) name not found...");
  }
}

function updateSelectAllValue(Object, fieldSelectedValues, reportName) {
  if (Object.length !== fieldSelectedValues?.length) {
    return fieldSelectedValues?.length > 0
      ? fieldSelectedValues?.join(",")
      : "0";
  } else if (
    // Object.selector === "#startUnit" &&
    reportName === "NPC_Cancel_by_Unit" ||
    reportName === "NPC_Delay_by_Unit" ||
    reportName === "NPC_Unit_Level_Metrics" ||
    reportName === "NPC_Task_Times_by_Unit"
  ) {
    return "-1";
  }
  return "0";
}

export function toggleUnits(rptObj) {
  const myObj = { startUnit: false, destUnit: false };
  if (
    rptObj?.report?.path === "NPC_Cancel_by_Unit" ||
    rptObj?.report?.path === "NPC_Delay_by_Unit" ||
    rptObj?.report?.path === "NPC_Unit_Level_Metrics" ||
    rptObj?.report?.path === "NPC_Task_Times_by_Unit"
  ) {
    if (
      rptObj["startUnit"]?.length <= 0 &&
      rptObj["destinationUnit"]?.length <= 0
    ) {
      return myObj;
    } else if (rptObj["startUnit"]?.length > 0) {
      myObj["destUnit"] = true;
      return myObj;
    } else if (rptObj["destinationUnit"]?.length > 0) {
      myObj["startUnit"] = true;
      return myObj;
    }
  }
}
